export class UserContentLibraryBridge {
	Id: number;
	ClientId: number;
	UserId: number;
	ContentLibraryId: number;
	ReadAccess: boolean;
	WriteAccess: boolean;
}